import React from 'react';
import { withRouter } from 'react-router';
import { IonButton, IonIcon } from '@ionic/react';
import { forwardTo } from '../../lib/utils';
import backArrow from '../../assets/images/icons/back_arrow.svg'

const BackButton = (props) => {
	const { history, path, style, className, backHandler, iconColor } = props;
	return (
		<IonButton
			className={className ? className : null}
			button
			clear
			onClick={() => (backHandler ? backHandler() : path ? forwardTo(path) : history.goBack())}
			style={style ? { ...style } : {}}
		>
			<IonIcon color={iconColor ? iconColor : 'dark'} slot="icon-only" icon={backArrow} />
		</IonButton>
	);
};

export default withRouter(BackButton);
